import React, { Suspense, lazy, useEffect, useState } from "react";
import { Routes, Route, useLocation, Link, Navigate, useNavigate } from "react-router-dom";
import { Button, Layout, Menu, theme } from "antd";
import PageNotFound from "./Pages/PageNotFound";
// import SideBarMenu from './Components/sidebar/SideBarMenu'
import SideBar from './Components/Sidebar'
import Loader from "./Components/Loader/Loader";
import PrivateRoute from "./Components/PrivateRoute";

import Sidebar from "./Components/SideBarMenu/SidebarMenu";
import AppHeader from "./Components/AppHeader/AppHeader";
import AuthenticatedRoutes from "./AuthenticatedRoutes/AllAuthenticatedRoutes";
import Login from "./Pages/login";

const { Content } = Layout;
export function AppRoutes() {
  const location = useLocation();
  const navigate = useNavigate();

  // Get token from localStorage (or any other auth check)
  const isLoggedIn = !!localStorage.getItem("token");
  // const isLoggedIn = true;
  // console.log("anuruddha", isLoggedIn)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      {isLoggedIn ? (
        <Route path="/*" element={<AuthenticatedRoutes />} />
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      )}
    </Routes>
  );
}

